import React from "react";
import { useLocation, Routes, Route, Navigate } from "react-router-dom";
import FinancialReport from "./FinancialReport";
import PayslipWithSelector from "../Payslip/PayslipWithSelector";
import Salary from "./Salary";
import SubHeader from "../Subheader/Subheader";
import "./FinancialReportTabs.css";

function FinancialReportTabs() {
  const location = useLocation();
  const isPayslipTab = location.pathname.includes("payslip");

  const tabs = [
    {
      id: "report",
      label: "ОТЧЕТ ПО СОТРУДНИКАМ",
      path: "employee",
    },
    {
      id: "payslip",
      label: "РАСЧЕТНЫЕ ЛИСТЫ",
      path: "payslip",
    },
    {
      id: "salary",
      label: "ЗАРАБОТНАЯ ПЛАТА",
      path: "salary",
    },
  ];

  return (
    <div className="financial-report-tabs">
      <SubHeader tabs={tabs} showRefreshButton={isPayslipTab} />
      <div className="financial-report-tabs__content">
        <Routes>
          <Route path="employee" element={<FinancialReport />} />
          <Route
            path="payslip"
            element={<PayslipWithSelector showSelector={true} />}
          />
          <Route path="salary" element={<Salary />} />
          <Route path="/" element={<Navigate to="employee" replace />} />
        </Routes>
      </div>
    </div>
  );
}

export default FinancialReportTabs;
